// /opt/isp_erp/frontend/src/components/tickets/TicketDetail.jsx

import { useAuth } from '../../auth/useAuth';
import React, { useState, useEffect, useRef } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import MaterialBuscador from './MaterialBuscador';
import VinetaBuscador from './VinetaBuscador';
import UbicacionCliente from './UbicacionCliente';
import EquiposIncidente from './EquiposIncidente';
import MovimientoEquipos from './MovimientoEquipos';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    Chip,
    Grid,
    TextField,
    IconButton,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    ListItemSecondaryAction,
    Avatar,
    Tabs,
    Tab,
    Paper,
    CircularProgress,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Divider,
    Alert,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Switch,
    FormControlLabel,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    InputAdornment
} from '@mui/material';
import {
    Close as CloseIcon,
    Person as PersonIcon,
    Phone as PhoneIcon,
    LocationOn as LocationIcon,
    MyLocation as MyLocationIcon,
    Comment as CommentIcon,
    CheckCircle as CheckCircleIcon,
    MedicalServices as MedicalIcon,
    Engineering as EngineeringIcon,
    Schedule as ScheduleIcon,
    Delete as DeleteIcon,
    Warning as WarningIcon,
    SwapHoriz as SwapHorizIcon,
    Add as AddIcon,
    Delete as DeleteIconMaterial,
    PhotoCamera as PhotoIcon,
    Inventory as InventoryIcon,
    Replay as ReplayIcon,
    History as HistoryIcon,
    Vignette as VignetteIcon,
    Delete as DeleteIconVignette,
    ExpandMore as ExpandMoreIcon,
    Search as SearchIcon,
    Clear as ClearIcon
} from '@mui/icons-material';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { ticketsAPI } from '../../api/tickets.api';
import { scheduleAPI } from '../../api/schedule.api';
import { warehouseAPI } from '../../api/warehouse.api';
import api from '../../api/axios';
import TicketTimeline from './TicketTimeline';
import CloseInstalacionDialog from './CloseInstalacionDialog';
import CloseRetiroDialog from './CloseRetiroDialog';
import CloseCambioEquipoDialog from './CloseCambioEquipoDialog';
import DateTimeSelector from '../DateTimeSelector';
import PDFButton from './PDFButton';
import FotoUploader from './FotoUploader';
import ClienteBitacora from './ClienteBitacora';

const statusColors = {
    abierto: 'default',
    en_diagnostico: 'primary',
    asignado_campo: 'warning',
    resuelto: 'success',
    cerrado: 'secondary',
    cancelado: 'error'
};

export default function TicketDetail({ open, onClose, ticket: initialTicket, onUpdate }) {
    const [activeTab, setActiveTab] = useState(0);
    const tema = useTheme();
    const esMovil = useMediaQuery(tema.breakpoints.down('sm'));
    const [newComment, setNewComment] = useState('');
    const [loading, setLoading] = useState(false);
    const [isLoadingTicket, setIsLoadingTicket] = useState(false);
    const { user } = useAuth();
    const [ticket, setTicket] = useState(initialTicket);
    const [closeDialogOpen, setCloseDialogOpen] = useState(false);
    const [closeRetiroDialogOpen, setCloseRetiroDialogOpen] = useState(false);
    const [closeCambioDialogOpen, setCloseCambioDialogOpen] = useState(false);
    const [diagnosticData, setDiagnosticData] = useState({
        ont_status: null,
        rx_power: '',
        tests_performed: '',
        diagnostic_notes: ''
    });
    const [fieldData, setFieldData] = useState({
        field_actions: '',
        final_rx_power: '',
        materials_used: '',
        evidence_photo_url: ''
    });
    const [technicians, setTechnicians] = useState([]);
    const [selectedTechnician, setSelectedTechnician] = useState('');
    const [visitDate, setVisitDate] = useState('');

    // Materiales
    const [materialesUtilizados, setMaterialesUtilizados] = useState([]);
    const precargaRef = useRef({ ticketId: null, firma: '' });
    const [catalogoMateriales, setCatalogoMateriales] = useState([]);
    const [nuevoMaterial, setNuevoMaterial] = useState({ material_id: '', cantidad: '1', observaciones: '' });
    const [equiposIncidente, setEquiposIncidente] = useState({ retirar: [], instalar: [] });
    useEffect(() => { if (!open) setEquiposIncidente({ retirar: [], instalar: [] }); }, [open]);
    const [stockTecnico, setStockTecnico] = useState([]);

    // ✅ Cambio de equipo
    const [equiposViejos, setEquiposViejos] = useState([]);
    const [equiposViejosSeleccionados, setEquiposViejosSeleccionados] = useState([]);
    const [equiposNuevosDisponibles, setEquiposNuevosDisponibles] = useState([]);
    const [equiposNuevosFiltrados, setEquiposNuevosFiltrados] = useState([]);
    const [equiposNuevosSeleccionados, setEquiposNuevosSeleccionados] = useState([]);
    const [selectedEquipoNuevo, setSelectedEquipoNuevo] = useState(null);
    const [searchEquipoNuevo, setSearchEquipoNuevo] = useState('');
    const [cargandoEquiposNuevos, setCargandoEquiposNuevos] = useState(false);
    const [motivoCambioEquipo, setMotivoCambioEquipo] = useState('');
    const [expandedViejos, setExpandedViejos] = useState(true);
    const [expandedNuevos, setExpandedNuevos] = useState(true);

    // ✅ Ubicación
    const [ubicacion, setUbicacion] = useState(null);
    const [obteniendoUbicacion, setObteniendoUbicacion] = useState(false);
    const [errorUbicacion, setErrorUbicacion] = useState('');
    const [usarUbicacion, setUsarUbicacion] = useState(true);

    // Fotos
    const [fotosBase64, setFotosBase64] = useState([]);

    // Bitácora
    const [bitacoraClienteOpen, setBitacoraClienteOpen] = useState(false);

    // Viñetas
    const [vinetaNueva, setVinetaNueva] = useState('');
    const [vinetaRetirar, setVinetaRetirar] = useState(false);
    const [vignettesDisponibles, setVignettesDisponibles] = useState([]);
    const [cargandoVignettes, setCargandoVignettes] = useState(false);
    const [customerVineta, setCustomerVineta] = useState('');

    // Disponibilidad
    const [checkingAvailability, setCheckingAvailability] = useState(false);
    const [availabilityError, setAvailabilityError] = useState('');
    const [isAvailable, setIsAvailable] = useState(null);

    const loadLatestTicket = async () => {
        if (!initialTicket?.id) return null;
        setIsLoadingTicket(true);
        try {
            const updatedTicket = await ticketsAPI.getById(initialTicket.id);
            setTicket(updatedTicket);
            return updatedTicket;
        } catch (error) {
            console.error('❌ Error loading ticket:', error);
            return null;
        } finally {
            setIsLoadingTicket(false);
        }
    };

    const refreshTicket = async () => {
        if (ticket && ticket.id) {
            try {
                const updatedTicket = await ticketsAPI.getById(ticket.id);
                setTicket(updatedTicket);
                if (onUpdate) onUpdate();
                return updatedTicket;
            } catch (error) {
                console.error('❌ Error refreshing ticket:', error);
            }
        }
        return null;
    };

    const cargarMateriales = async () => {
        try {
            const response = { data: [] }; // el buscador consulta al servidor: ya no se descarga el catálogo completo
            setCatalogoMateriales(response.data || []);
        } catch (error) {
            console.error('Error cargando materiales:', error);
        }
    };

    const cargarStockTecnico = async (tecnicoId) => {
        if (!tecnicoId) return;
        try {
            const response = await api.get(`/warehouse/materiales/stock-tecnico/${tecnicoId}`);
            setStockTecnico(response.data || []);
        } catch (error) {
            console.error('Error cargando stock del técnico:', error);
            setStockTecnico([]);
        }
    };

    // ✅ Cargar equipos VIEJOS
    const cargarEquiposViejos = async () => {
        if (!ticket) return;

        const viejosMap = new Map();

        const viejosDelTicket = ticket.materials_used?.equipos_viejos || [];
        viejosDelTicket.forEach(v => {
            if (v.sn) {
                viejosMap.set(v.sn, {
                    sn: v.sn,
                    modelo: v.modelo || 'DESCONOCIDO',
                    motivo: v.motivo || ''
                });
            }
        });

        if (ticket.customer_id) {
            try {
                const response = await warehouseAPI.listarEquipos({ estado: 'INSTALADO' });
                const todos = response?.data || [];

                const delCliente = todos.filter(eq => {
                    const cid = eq.customer_id;
                    return cid && parseInt(cid) === parseInt(ticket.customer_id);
                });

                delCliente.forEach(eq => {
                    if (eq.sn && !viejosMap.has(eq.sn)) {
                        viejosMap.set(eq.sn, {
                            sn: eq.sn,
                            modelo: eq.modelo || 'DESCONOCIDO',
                            motivo: ''
                        });
                    }
                });
            } catch (error) {
                console.warn('No se pudieron cargar equipos instalados del cliente:', error);
            }
        }

        const equiposFinales = Array.from(viejosMap.values());
        setEquiposViejos(equiposFinales);
        setEquiposViejosSeleccionados([]);
    };

    // ✅ Cargar equipos NUEVOS
    const cargarEquiposNuevosDisponibles = async (tecnicoId) => {
        if (!tecnicoId) return;
        setCargandoEquiposNuevos(true);
        try {
            const response = await warehouseAPI.listarEquipos({ estado: 'EN_TRANSITO' });
            const todos = response?.data || [];

            const delTecnico = todos.filter(equipo => {
                const tipo = equipo.poseedor?.tipo;
                const id = equipo.poseedor?.id;
                return tipo &&
                       (tipo === 'Técnico' || tipo === 'tecnico') &&
                       parseInt(id) === parseInt(tecnicoId);
            });

            setEquiposNuevosDisponibles(delTecnico);
            setEquiposNuevosFiltrados(delTecnico);
        } catch (error) {
            console.error('Error cargando equipos nuevos:', error);
            setEquiposNuevosDisponibles([]);
            setEquiposNuevosFiltrados([]);
        } finally {
            setCargandoEquiposNuevos(false);
        }
    };

    useEffect(() => {
        if (searchEquipoNuevo.trim()) {
            const filtrados = equiposNuevosDisponibles.filter(e =>
                e.sn?.toLowerCase().includes(searchEquipoNuevo.toLowerCase()) ||
                e.modelo?.toLowerCase().includes(searchEquipoNuevo.toLowerCase())
            );
            setEquiposNuevosFiltrados(filtrados);
        } else {
            setEquiposNuevosFiltrados(equiposNuevosDisponibles);
        }
    }, [searchEquipoNuevo, equiposNuevosDisponibles]);

    const cargarVignettesDisponibles = async () => {
        if (!ticket?.assigned_technician_id) return;
        setCargandoVignettes(true);
        try {
            const response = await api.get(`/warehouse/vignettes?tecnico_id=${ticket.assigned_technician_id}`);
            const data = response.data || [];
            const disponibles = data.filter(v =>
                v.estado === 'ASIGNADO' && v.tecnico_id === ticket.assigned_technician_id
            );
            setVignettesDisponibles(disponibles.map(v => ({ ...v, asignada_a_tecnico: true })));
        } catch (error) {
            console.error('❌ Error cargando viñetas:', error);
            setVignettesDisponibles([]);
        } finally {
            setCargandoVignettes(false);
        }
    };

    // Selección desde el buscador de materiales: registra el material elegido y su stock para las validaciones
    const seleccionarMaterial = (item) => {
      if (!item) {
        setNuevoMaterial(prev => ({ ...prev, material_id: '' }));
        return;
      }
      setCatalogoMateriales(prev => prev.some(m => m.id === item.material_id)
        ? prev
        : [...prev, { id: item.material_id, codigo: item.codigo, nombre: item.nombre, unidad: item.unidad }]);
      setStockTecnico(prev => [...prev.filter(s => s.material_id !== item.material_id),
        { material_id: item.material_id, cantidad: item.disponible }]);
      setNuevoMaterial(prev => ({ ...prev, material_id: item.material_id }));
    };

    const agregarMaterial = () => {
        if (!nuevoMaterial.material_id) {
            alert('Seleccione un material');
            return;
        }
        const cantidadNum = parseFloat(nuevoMaterial.cantidad);
        if (isNaN(cantidadNum) || cantidadNum < 1) {
            alert('Ingrese una cantidad válida');
            return;
        }
        const stockMat = stockTecnico.find(s => s.material_id === nuevoMaterial.material_id);
        if (stockMat && stockMat.cantidad < cantidadNum) {
            alert(`Stock insuficiente. Disponible: ${stockMat.cantidad}`);
            return;
        }
        const info = catalogoMateriales.find(m => m.id === nuevoMaterial.material_id);
        setMaterialesUtilizados([...materialesUtilizados, {
            material_id: nuevoMaterial.material_id,
            nombre: info?.nombre,
            cantidad: cantidadNum,
            observaciones: nuevoMaterial.observaciones
        }]);
        setNuevoMaterial({ material_id: '', cantidad: '1', observaciones: '' });
    };

    const eliminarMaterial = (index) => {
        setMaterialesUtilizados(materialesUtilizados.filter((_, i) => i !== index));
    };

    // ✅ Ubicación
    const obtenerUbicacion = () => {
        if (!navigator.geolocation) {
            setErrorUbicacion('Geolocalización no soportada');
            setUsarUbicacion(false);
            return;
        }

        setObteniendoUbicacion(true);
        setErrorUbicacion('');

        navigator.geolocation.getCurrentPosition(
            (position) => {
                setUbicacion({
                    latitud: position.coords.latitude,
                    longitud: position.coords.longitude,
                    precision: position.coords.accuracy
                });
                setObteniendoUbicacion(false);
            },
            (error) => {
                console.error('Error de geolocalización:', error);
                let mensaje = '';
                switch(error.code) {
                    case error.PERMISSION_DENIED:
                        mensaje = 'Permiso denegado. Activa la ubicación en tu dispositivo.';
                        break;
                    case error.POSITION_UNAVAILABLE:
                        mensaje = 'No se pudo obtener la ubicación. Verifica tu GPS.';
                        break;
                    case error.TIMEOUT:
                        mensaje = 'Tiempo de espera agotado. Intenta nuevamente.';
                        break;
                    default:
                        mensaje = 'Error al obtener ubicación.';
                }
                setErrorUbicacion(mensaje);
                setObteniendoUbicacion(false);
                setUsarUbicacion(false);
            },
            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0
            }
        );
    };

    // ✅ Cambio de equipo - helpers
    const toggleEquipoViejo = (sn) => {
        setEquiposViejosSeleccionados(prev =>
            prev.includes(sn) ? prev.filter(s => s !== sn) : [...prev, sn]
        );
    };

    const agregarEquipoViejoManual = () => {
        const sn = window.prompt('Ingrese el número de serie del equipo viejo a retirar:');
        if (!sn || !sn.trim()) return;

        const snLimpio = sn.trim();
        if (equiposViejos.some(e => e.sn === snLimpio)) {
            alert('Este equipo ya está en la lista');
            return;
        }

        const motivo = window.prompt('Motivo del retiro (opcional):') || '';

        setEquiposViejos([...equiposViejos, {
            sn: snLimpio,
            modelo: 'Ingresado manualmente',
            motivo
        }]);
        setEquiposViejosSeleccionados(prev => [...prev, snLimpio]);
    };

    const eliminarEquipoViejo = (sn) => {
        setEquiposViejos(equiposViejos.filter(e => e.sn !== sn));
        setEquiposViejosSeleccionados(prev => prev.filter(s => s !== sn));
    };

    const agregarEquipoNuevo = () => {
        if (!selectedEquipoNuevo) {
            alert('Seleccione un equipo nuevo');
            return;
        }
        if (equiposNuevosSeleccionados.some(e => e.sn === selectedEquipoNuevo.sn)) {
            alert('Ya está en la lista');
            return;
        }
        setEquiposNuevosSeleccionados([...equiposNuevosSeleccionados, {
            sn: selectedEquipoNuevo.sn,
            tipo: 'ONU',
            modelo: selectedEquipoNuevo.modelo || 'DESCONOCIDO'
        }]);
        setSelectedEquipoNuevo(null);
    };

    const eliminarEquipoNuevo = (index) => {
        setEquiposNuevosSeleccionados(equiposNuevosSeleccionados.filter((_, i) => i !== index));
    };

    const actualizarTipoEquipoNuevo = (index, tipo) => {
        const nuevos = [...equiposNuevosSeleccionados];
        nuevos[index].tipo = tipo;
        setEquiposNuevosSeleccionados(nuevos);
    };

    // ✅ Procesar cambio de equipo CON UBICACIÓN
    const handleProcesarCambioEquipo = async () => {
        if (equiposViejosSeleccionados.length === 0) {
            alert('Debe seleccionar al menos un equipo viejo');
            return;
        }
        if (equiposNuevosSeleccionados.length === 0) {
            alert('Debe agregar al menos un equipo nuevo');
            return;
        }
        if (materialesUtilizados.length === 0) {
            alert('Debe registrar al menos un material utilizado');
            return;
        }

        if (!window.confirm(`¿Procesar cambio de ${equiposViejosSeleccionados.length} equipo(s) viejo(s) por ${equiposNuevosSeleccionados.length} equipo(s) nuevo(s)? Se cerrará el ticket.`)) return;

        setLoading(true);
        try {
            const equiposViejosFinal = equiposViejos
                .filter(e => equiposViejosSeleccionados.includes(e.sn))
                .map(e => ({
                    sn: e.sn,
                    motivo: e.motivo || motivoCambioEquipo || 'Cambio de equipo'
                }));

            const materialesEnvio = materialesUtilizados.map(m => ({
                material_id: m.material_id,
                nombre: m.nombre,
                cantidad: m.cantidad,
                observaciones: m.observaciones || ''
            }));

            // ✅ Preparar ubicación
            let ubicacionData = null;
            if (usarUbicacion && ubicacion) {
                ubicacionData = {
                    latitud: ubicacion.latitud,
                    longitud: ubicacion.longitud,
                    precision: ubicacion.precision
                };
            }

            await ticketsAPI.closeCambioEquipoTicket(
                ticket.id,
                equiposViejosFinal,
                equiposNuevosSeleccionados,
                materialesEnvio,
                motivoCambioEquipo || 'Cambio de equipo',
                fotosBase64,
                ubicacionData,   // ✅ Enviar ubicación
                vinetaNueva || undefined,
                vinetaRetirar
            );

            alert('✅ Cambio de equipo completado. Ticket cerrado.');
            await refreshTicket();
            onClose();
        } catch (error) {
            console.error('Error procesando cambio:', error);
            alert(error.response?.data?.detail || 'Error al procesar el cambio de equipo');
        } finally {
            setLoading(false);
        }
    };

    const handleCloseInstallation = () => setCloseDialogOpen(true);
    const handleCloseRetiro = () => setCloseRetiroDialogOpen(true);
    const handleCloseCambio = () => setCloseCambioDialogOpen(true);
    const handleCloseSuccess = () => refreshTicket();

    useEffect(() => {
        if (open && initialTicket?.id) {
            loadLatestTicket();
            cargarMateriales();
        }
    }, [open, initialTicket?.id]);

    useEffect(() => {
        if (open && ticket?.assigned_technician_id) {
            cargarStockTecnico(ticket.assigned_technician_id);
        }
    }, [open, ticket?.assigned_technician_id, ticket?.customer_id]);

    // ✅ Auto-obtener ubicación al abrir el tab "Trabajo Campo"
    useEffect(() => {
        if (open && activeTab === 3 && canDoFieldWork && usarUbicacion && !ubicacion) {
            obtenerUbicacion();
        }
    }, [open, activeTab]);

    useEffect(() => {
        if (ticket && ticket.customer_id) {
            api.get(`/customers/${ticket.customer_id}`)
                .then(res => {
                    setCustomerVineta(res.data?.vineta || '');
                    if (ticket.assigned_technician_id) {
                        setTimeout(() => cargarVignettesDisponibles(), 100);
                    }
                })
                .catch(err => console.error('Error obteniendo viñeta:', err));
        }
    }, [ticket?.customer_id, ticket?.assigned_technician_id]);

    useEffect(() => {
        if (ticket) {
            if (ticket.tests_performed && Array.isArray(ticket.tests_performed)) {
                setDiagnosticData({ ...diagnosticData, tests_performed: ticket.tests_performed.join(', ') });
            }
            if (ticket.diagnostic_notes) setDiagnosticData(prev => ({ ...prev, diagnostic_notes: ticket.diagnostic_notes }));
            if (ticket.ont_status !== undefined) setDiagnosticData(prev => ({ ...prev, ont_status: ticket.ont_status }));
            if (ticket.rx_power) setDiagnosticData(prev => ({ ...prev, rx_power: ticket.rx_power }));
            if (ticket.field_actions) setFieldData(prev => ({ ...prev, field_actions: ticket.field_actions }));
            if (ticket.final_rx_power) setFieldData(prev => ({ ...prev, final_rx_power: ticket.final_rx_power }));
            if (ticket.evidence_photo_url) setFieldData(prev => ({ ...prev, evidence_photo_url: ticket.evidence_photo_url }));
            if (ticket.materials_used && typeof ticket.materials_used === 'object' && ticket.materials_used.materiales_lista) {
                    const listaVieja = ticket.materials_used.materiales_lista;
                    // No pisa lo que el técnico ya agregó: solo reemplaza si la lista sigue intacta o es de otro ticket
                    const poner = (nueva) => setMaterialesUtilizados((prev) => {
                        const firma = (lista) => JSON.stringify((lista || []).map((m) => [m.material_id || null, m.nombre, m.cantidad]));
                        const mismoTicket = precargaRef.current.ticketId === ticket.id;
                        if (mismoTicket && prev && prev.length > 0 && firma(prev) !== precargaRef.current.firma) return prev;
                        precargaRef.current = { ticketId: ticket.id, firma: firma(nueva) };
                        return nueva || [];
                    });
                    // Si el ticket ya descontó materiales (se reabrió), se cargan desde el kardex con su id para corregirlos
                    api.get(`/tickets/${ticket.id}/cierre-previo`)
                        .then((r) => {
                            const previos = (r.data && r.data.materiales) || [];
                            if (previos.length > 0) {
                                const obs = {};
                                (listaVieja || []).forEach((m) => { obs[m.nombre] = m.observaciones || ''; });
                                poner(previos.map((m) => ({
                                    material_id: m.material_id, nombre: m.nombre, cantidad: m.cantidad, observaciones: obs[m.nombre] || ''
                                })));
                            } else {
                                poner(listaVieja);
                            }
                        })
                        .catch(() => poner(listaVieja));
            }
        }
    }, [ticket]);

    useEffect(() => {
        if (open) loadTechnicians();
    }, [open]);

    const loadTechnicians = async () => {
        try {
            const data = await ticketsAPI.getTechnicians();
            setTechnicians(data || []);
        } catch (error) {
            console.error('Error loading technicians:', error);
            setTechnicians([]);
        }
    };

    if (isLoadingTicket) {
        return (
            <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
                <DialogContent>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 300 }}>
                        <CircularProgress />
                        <Typography sx={{ ml: 2 }}>Cargando ticket...</Typography>
                    </Box>
                </DialogContent>
            </Dialog>
        );
    }

    if (!ticket) return null;

    const handleAddComment = async () => {
        if (!newComment.trim()) return;
        setLoading(true);
        try {
            await ticketsAPI.addComment(ticket.id, { comment: newComment, is_internal: false });
            setNewComment('');
            await refreshTicket();
        } catch (error) {
            console.error('❌ Error adding comment:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateDiagnostic = async () => {
        setLoading(true);
        try {
            await ticketsAPI.updateDiagnostic(ticket.id, {
                ont_status: diagnosticData.ont_status,
                rx_power: diagnosticData.rx_power ? parseFloat(diagnosticData.rx_power) : null,
                tests_performed: diagnosticData.tests_performed.split(',').map(t => t.trim()).filter(t => t),
                diagnostic_notes: diagnosticData.diagnostic_notes
            });
            await refreshTicket();
        } catch (error) {
            console.error('❌ Error updating diagnostic:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleResolveRemotely = async () => {
        if (!window.confirm('¿Resolver remotamente?')) return;
        setLoading(true);
        try {
            await ticketsAPI.resolve(ticket.id, {
                resolution_notes: diagnosticData.diagnostic_notes || 'Resuelto remotamente',
                speed_test_result: { download: null, upload: null, ping: null }
            });
            await refreshTicket();
            onClose();
        } catch (error) {
            console.error('❌ Error:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleScheduleVisit = async () => {
        if (!selectedTechnician || !visitDate) {
            alert('Seleccione técnico y fecha');
            return;
        }
        setCheckingAvailability(true);
        setAvailabilityError('');
        setIsAvailable(null);
        try {
            let fechaStr = visitDate.includes('T') ? visitDate.split('T')[0] : visitDate;
            const response = await api.get(`/tickets/tecnicos-disponibles-por-fecha`, { params: { fecha: fechaStr } });
            const tecnicosDisponibles = response.data || [];
            const tecnicoDisponible = tecnicosDisponibles.some(t => t.id === parseInt(selectedTechnician));

            if (!tecnicoDisponible) {
                setAvailabilityError(`⚠️ El técnico no está disponible en esta fecha (${fechaStr}).`);
                setIsAvailable(false);
                setCheckingAvailability(false);
                return;
            }

            const result = await scheduleAPI.checkAvailability(selectedTechnician, visitDate, 60);
            if (!result.available) {
                setAvailabilityError('El técnico ya tiene un trabajo en este horario.');
                setIsAvailable(false);
                setCheckingAvailability(false);
                return;
            }

            setIsAvailable(true);
            setLoading(true);
            await ticketsAPI.scheduleVisit(ticket.id, visitDate, selectedTechnician);
            await refreshTicket();
            setSelectedTechnician('');
            setVisitDate('');
            setIsAvailable(null);
        } catch (err) {
            setAvailabilityError(err.response?.data?.detail || 'Error');
            setIsAvailable(false);
        } finally {
            setCheckingAvailability(false);
            setLoading(false);
        }
    };


    const handleUpdateFieldWork = async () => {
        setLoading(true);
        try {
            let materials = {};
            if (materialesUtilizados.length > 0) {
                materials.materiales_lista = materialesUtilizados;
            }

            // ✅ Preparar ubicación
            let ubicacionData = null;
            if (usarUbicacion && ubicacion) {
                ubicacionData = {
                    latitud: ubicacion.latitud,
                    longitud: ubicacion.longitud,
                    precision: ubicacion.precision
                };
            } 

            await ticketsAPI.updateFieldWork(ticket.id, {
                field_actions: fieldData.field_actions,
                final_rx_power: fieldData.final_rx_power ? parseFloat(fieldData.final_rx_power) : null,
                materials_used: materials,
                evidence_photo_url: fieldData.evidence_photo_url,
                ubicacion: ubicacionData
            });
            await refreshTicket();
            alert('✅ Trabajo guardado' + (ubicacionData ? ' con ubicación actualizada' : ''));
        } catch (error) {
            alert('Error: ' + (error.response?.data?.detail || error.message));
        } finally {
            setLoading(false);
        }
    };

    const handleResolve = async () => {
        if (vinetaRetirar && vinetaNueva) {
            alert('No puede retirar y cambiar viñeta al mismo tiempo.');
            return;
        }
        if (!window.confirm('¿Marcar como resuelto?')) return;

        setLoading(true);
        try {
            // ✅ Preparar ubicación para resolver también
            let ubicacionData = null;
            if (usarUbicacion && ubicacion) {
                ubicacionData = {
                    latitud: ubicacion.latitud,
                    longitud: ubicacion.longitud,
                    precision: ubicacion.precision
                };
            }


            const payload = {
                resolution_notes: fieldData.field_actions || 'Ticket resuelto',
                materiales_utilizados: materialesUtilizados.map(m => ({
                    material_id: m.material_id,
                    nombre: m.nombre,
                    cantidad: m.cantidad,
                    observaciones: m.observaciones || ''
                })),
                fotos: fotosBase64,
                equipos_retirar: equiposIncidente.retirar.map(e => ({ sn: e.sn, motivo: e.motivo || '' })),
                equipos_instalar: equiposIncidente.instalar.map(e => ({ sn: e.sn, tipo: e.tipo, modelo: e.modelo })),
            equipos_comentario: (equiposIncidente.comentario || '').trim(),
                ubicacion: ubicacionData,   // ✅ También en resolver
                vineta_nueva: vinetaNueva || undefined,
                vineta_retirar: vinetaRetirar
            };
            await ticketsAPI.resolve(ticket.id, payload);
            setEquiposIncidente({ retirar: [], instalar: [] });
            await refreshTicket();
            alert('✅ Ticket resuelto');
            onClose();
        } catch (error) {
            alert(error.response?.data?.detail || 'Error al resolver');
        } finally {
            setLoading(false);
        }
    };

    const handleCloseTicket = async () => {
        if (!window.confirm('¿Cerrar definitivamente?')) return;
        setLoading(true);
        try {
            await ticketsAPI.close(ticket.id);
            await refreshTicket();
            onClose();
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteTicket = async () => {
        if (!window.confirm('¿Eliminar definitivamente?')) return;
        setLoading(true);
        try {
            await ticketsAPI.deleteTicket(ticket.id);
            if (onUpdate) onUpdate();
            onClose();
        } catch (error) {
            alert(error.response?.data?.detail || 'Error');
        } finally {
            setLoading(false);
        }
    };

    const handleReopenTicket = async () => {
        const motivo = window.prompt('Motivo (opcional):');
        setLoading(true);
        try {
            await ticketsAPI.reopenTicket(ticket.id, motivo || '');
            await refreshTicket();
            alert('✅ Ticket reabierto');
        } catch (error) {
            alert(error.response?.data?.detail || 'Error');
        } finally {
            setLoading(false);
        }
    };

    const canDiagnose = ticket.status === 'abierto' || ticket.status === 'en_diagnostico';
    const canAssign = ticket.status === 'en_diagnostico';
    const canDoFieldWork = ticket.status === 'asignado_campo';
    const canResolve = ticket.status === 'asignado_campo';
    const canClose = ticket.status === 'resuelto';
    const canResolveRemotely = ticket.status === 'abierto' || ticket.status === 'en_diagnostico';
    const canCloseInstallation = ticket.ticket_type === 'instalacion' && ticket.status === 'abierto';
    const canCloseRetiro = ticket.ticket_type === 'retiro' && ticket.status === 'abierto';
    const canCloseCambio = ticket.ticket_type?.toUpperCase() === 'CAMBIO_EQUIPO' && ticket.status === 'abierto';

    const canReopen = (ticket.status === 'resuelto' || ticket.status === 'cerrado') &&
                      (user?.is_superuser || user?.roles?.includes('admin') || user?.roles?.includes('supervisor'));

    const getPDFType = () => {
        if (ticket.ticket_type === 'instalacion') return 'instalacion';
        if (ticket.ticket_type?.toUpperCase() === 'CAMBIO_EQUIPO') return 'cambio_equipo';
        if (ticket.ticket_type === 'retiro') return 'retiro';
        return 'incidente';
    };

    const getPDFExtraData = () => {
        const data = {};
        if (ticket.materials_used && typeof ticket.materials_used === 'object') {
            if (ticket.materials_used.equipos_retirados) data.equipos = ticket.materials_used.equipos_retirados;
            else if (ticket.materials_used.equipos) data.equipos = ticket.materials_used.equipos;
            if (ticket.materials_used.equipos_viejos) data.equipos_viejos = ticket.materials_used.equipos_viejos;
            if (ticket.materials_used.equipos_nuevos) data.equipos_nuevos = ticket.materials_used.equipos_nuevos;
            if (ticket.materials_used.materiales_consumidos) data.materiales = ticket.materials_used.materiales_consumidos;
            else if (ticket.materials_used.materiales_lista) data.materiales = ticket.materials_used.materiales_lista;
            else if (ticket.materials_used.materiales) data.materiales = ticket.materials_used.materiales;
        }
        return data;
    };

    return (
        <>
            <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth fullScreen={esMovil}>
                <DialogTitle>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Box>
                            <Typography variant="h6">
                                Ticket {ticket.ticket_number}
                                <Chip label={ticket.status} color={statusColors[ticket.status] || 'default'} size="small" sx={{ ml: 2 }} />
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                            {(ticket.status?.toLowerCase() === 'cerrado' || ticket.status?.toLowerCase() === 'resuelto') && (
                                <PDFButton ticketId={ticket.id} ticketNumber={ticket.ticket_number} type={getPDFType()} extraData={getPDFExtraData()} variant="icon" />
                            )}
                            <IconButton onClick={onClose} size="small"><CloseIcon /></IconButton>
                        </Box>
                    </Box>
                </DialogTitle>

                <DialogContent dividers>
                    <Grid container spacing={2}>
                        {/* Cliente */}
                        <Grid item xs={12}>
                            <Paper variant="outlined" sx={{ p: 2 }}>
                                <Typography variant="subtitle2" color="primary" gutterBottom>Información del Cliente</Typography>
                                <Box display="flex" alignItems="center" mb={1}>
                                    <PersonIcon fontSize="small" sx={{ mr: 1, color: 'text.secondary' }} />
                                    <Typography variant="body2">{ticket.customer_name || `Cliente ID: ${ticket.customer_id}`}</Typography>
                                </Box>
                                <Box display="flex" alignItems="center" mb={1}>
                                    <PhoneIcon fontSize="small" sx={{ mr: 1, color: 'text.secondary' }} />
                                    <Typography variant="body2">{ticket.contact_phone}</Typography>
                                </Box>
                                <UbicacionCliente ticket={ticket} />
                                <MovimientoEquipos ticket={ticket} />
                                {ticket.customer_address && (
                                    <Box display="flex" alignItems="center">
                                        <LocationIcon fontSize="small" sx={{ mr: 1, color: 'text.secondary' }} />
                                        <Typography variant="body2">{ticket.customer_address}</Typography>
                                    </Box>
                                )}
                                {ticket.customer_id && (
                                    <Button variant="outlined" size="small" startIcon={<HistoryIcon />} onClick={() => setBitacoraClienteOpen(true)} sx={{ mt: 1 }}>
                                        Ver Bitácora del Cliente
                                    </Button>
                                )}
                            </Paper>
                        </Grid>

                        {/* SLA */}
                        <Grid item xs={12}>
                            <Paper variant="outlined" sx={{ p: 2 }}>
                                <Typography variant="subtitle2" color="primary" gutterBottom>Tiempos SLA</Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <Typography variant="caption" color="text.secondary">Límite de Respuesta</Typography>
                                        <Typography variant="body2">{ticket.response_deadline ? format(new Date(ticket.response_deadline), 'dd/MM/yyyy HH:mm', { locale: es }) : 'No definido'}</Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="caption" color="text.secondary">Límite de Resolución</Typography>
                                        <Typography variant="body2">{ticket.resolution_deadline ? format(new Date(ticket.resolution_deadline), 'dd/MM/yyyy HH:mm', { locale: es }) : 'No definido'}</Typography>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>

                        {/* Timeline */}
                        <Grid item xs={12}>
                            <Paper variant="outlined" sx={{ p: 2 }}>
                                <Typography variant="subtitle2" color="primary" gutterBottom>Línea de Tiempo</Typography>
                                <TicketTimeline ticket={ticket} />
                            </Paper>
                        </Grid>

                        {/* Tabs */}
                        <Grid item xs={12}>
                            <Tabs value={activeTab} onChange={(e, v) => setActiveTab(v)} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile>
                                <Tab label="Comentarios" />
                                <Tab label="Diagnóstico" disabled={!canDiagnose && !ticket.diagnostic_notes} />
                                <Tab label="Asignación" disabled={!canAssign} />
                                <Tab label="Trabajo Campo" disabled={!canDoFieldWork && !ticket.field_actions} />
                                <Tab label="Cierre" />
                            </Tabs>

                            <Box sx={{ mt: 2 }}>
                                {activeTab === 0 && (
                                    <Box>
                                        <TextField fullWidth multiline rows={3} placeholder="Agregar un comentario..." value={newComment} onChange={(e) => setNewComment(e.target.value)} disabled={loading} />
                                        <Button variant="contained" onClick={handleAddComment} disabled={!newComment.trim() || loading} sx={{ mt: 1 }}>
                                            {loading ? <CircularProgress size={24} /> : 'Agregar Comentario'}
                                        </Button>
                                        <List sx={{ mt: 2 }}>
                                            {ticket.comments?.map((comment, idx) => (
                                                <ListItem key={idx} divider>
                                                    <ListItemAvatar><Avatar sx={{ bgcolor: 'primary.main' }}><CommentIcon /></Avatar></ListItemAvatar>
                                                    <ListItemText primary={comment.user_name} secondary={comment.comment} />
                                                    <Typography variant="caption" color="text.secondary">
                                                        {comment.created_at ? format(new Date(comment.created_at), 'dd/MM/yyyy HH:mm') : ''}
                                                    </Typography>
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Box>
                                )}

                                {activeTab === 1 && (
                                    <Box>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <FormControl fullWidth>
                                                    <InputLabel>Estado ONT</InputLabel>
                                                    <Select value={diagnosticData.ont_status === null ? '' : String(diagnosticData.ont_status)} onChange={(e) => setDiagnosticData({ ...diagnosticData, ont_status: e.target.value === 'true' })} label="Estado ONT">
                                                        <MenuItem value="true">Online</MenuItem>
                                                        <MenuItem value="false">Offline</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField fullWidth label="Potencia RX (dBm)" type="number" value={diagnosticData.rx_power} onChange={(e) => setDiagnosticData({ ...diagnosticData, rx_power: e.target.value })} />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField fullWidth label="Pruebas realizadas" value={diagnosticData.tests_performed} onChange={(e) => setDiagnosticData({ ...diagnosticData, tests_performed: e.target.value })} />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField fullWidth multiline rows={3} label="Notas de diagnóstico" value={diagnosticData.diagnostic_notes} onChange={(e) => setDiagnosticData({ ...diagnosticData, diagnostic_notes: e.target.value })} />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Button variant="contained" onClick={handleUpdateDiagnostic} disabled={loading} startIcon={<MedicalIcon />}>Guardar Diagnóstico</Button>
                                                {canResolveRemotely && (
                                                    <Button variant="contained" color="success" onClick={handleResolveRemotely} disabled={loading} startIcon={<CheckCircleIcon />} sx={{ ml: 2 }}>
                                                        Resolver (Remoto)
                                                    </Button>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Box>
                                )}

                                {activeTab === 2 && (
                                    <Box>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <FormControl fullWidth>
                                                    <InputLabel>Técnico</InputLabel>
                                                    <Select value={selectedTechnician} onChange={(e) => { setSelectedTechnician(e.target.value); setAvailabilityError(''); setIsAvailable(null); setVisitDate(''); }} label="Técnico">
                                                        {technicians.map((tech) => (
                                                            <MenuItem key={tech.id} value={tech.id}>{tech.full_name} - {tech.phone || 'Sin tel'}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <DateTimeSelector
                                                    technicianId={selectedTechnician}
                                                    onDateTimeChange={(date) => {
                                                        if (!date) { setVisitDate(''); setAvailabilityError(''); setIsAvailable(null); return; }
                                                        const localDateTime = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}T${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
                                                        setVisitDate(localDateTime);
                                                    }}
                                                    durationMinutes={60}
                                                    label="Fecha Visita"
                                                />
                                                {availabilityError && <Alert severity="error" sx={{ mt: 1 }}>{availabilityError}</Alert>}
                                                {isAvailable === true && visitDate && <Alert severity="success" sx={{ mt: 1 }}>✅ Disponible</Alert>}
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Button variant="contained" onClick={handleScheduleVisit} disabled={loading || checkingAvailability || !selectedTechnician || !visitDate} startIcon={checkingAvailability ? <CircularProgress size={20} /> : <ScheduleIcon />}>
                                                    {checkingAvailability ? 'Verificando...' : 'Programar Visita'}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                )}

                                {activeTab === 3 && (
                                    <Box>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <TextField fullWidth multiline rows={3} label="Acciones realizadas" value={fieldData.field_actions} onChange={(e) => setFieldData({ ...fieldData, field_actions: e.target.value })} />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField fullWidth label="Potencia final (dBm)" type="number" value={fieldData.final_rx_power} onChange={(e) => setFieldData({ ...fieldData, final_rx_power: e.target.value })} />
                                            </Grid>

                                            {/* ✅ SECCIÓN UBICACIÓN */}
                                            <Grid item xs={12}>
                                                <Paper sx={{ p: 2, mb: 2, bgcolor: '#f5f5f5' }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                                                        <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <LocationIcon color="primary" />
                                                            Ubicación
                                                        </Typography>
                                                        <FormControlLabel
                                                            control={
                                                                <Switch
                                                                    checked={usarUbicacion}
                                                                    onChange={(e) => setUsarUbicacion(e.target.checked)}
                                                                    size="small"
                                                                />
                                                            }
                                                            label="Guardar ubicación"
                                                        />
                                                    </Box>

                                                    {usarUbicacion && (
                                                        <>
                                                            {!ubicacion && !obteniendoUbicacion && !errorUbicacion && (
                                                                <Button
                                                                    size="small"
                                                                    variant="outlined"
                                                                    startIcon={<MyLocationIcon />}
                                                                    onClick={obtenerUbicacion}
                                                                    fullWidth
                                                                >
                                                                    Obtener ubicación actual
                                                                </Button>
                                                            )}

                                                            {obteniendoUbicacion && (
                                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                    <CircularProgress size={20} />
                                                                    <Typography variant="body2">Obteniendo ubicación...</Typography>
                                                                </Box>
                                                            )}

                                                            {errorUbicacion && (
                                                                <>
                                                                    <Alert severity="warning" size="small" sx={{ mt: 1 }}>
                                                                        {errorUbicacion}
                                                                    </Alert>
                                                                    <Button
                                                                        size="small"
                                                                        variant="outlined"
                                                                        startIcon={<MyLocationIcon />}
                                                                        onClick={obtenerUbicacion}
                                                                        sx={{ mt: 1 }}
                                                                        fullWidth
                                                                    >
                                                                        Reintentar
                                                                    </Button>
                                                                </>
                                                            )}

                                                            {ubicacion && (
                                                                <>
                                                                    <Alert severity="success" sx={{ mt: 1 }} icon={<MyLocationIcon />}>
                                                                        <Typography variant="caption" display="block">
                                                                            Lat: {ubicacion.latitud.toFixed(6)} | Lng: {ubicacion.longitud.toFixed(6)}
                                                                        </Typography>
                                                                        {ubicacion.precision && (
                                                                            <Typography variant="caption" display="block" color="text.secondary">
                                                                                Precisión: ±{Math.round(ubicacion.precision)}m
                                                                            </Typography>
                                                                        )}
                                                                    </Alert>
                                                                    <Button
                                                                        size="small"
                                                                        variant="text"
                                                                        startIcon={<MyLocationIcon />}
                                                                        onClick={obtenerUbicacion}
                                                                        sx={{ mt: 1 }}
                                                                        fullWidth
                                                                    >
                                                                        Actualizar ubicación
                                                                    </Button>
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                </Paper>
                                            </Grid>

                                            {/* FOTOS */}
                                            <Grid item xs={12}>
                                                <Typography variant="subtitle1" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <PhotoIcon color="primary" />
                                                    Evidencia Fotográfica
                                                </Typography>
                                                <FotoUploader onFotosChange={setFotosBase64} maxFotos={9} label="Fotos" />
                                            </Grid>

                                            <Grid item xs={12}>
                                              <Typography variant="subtitle1" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <InventoryIcon color="primary" />
                                                Equipos
                                              </Typography>
                                              <EquiposIncidente ticketId={ticket?.id} value={equiposIncidente} onChange={setEquiposIncidente} />
                                            </Grid>
                                            {/* MATERIALES */}
                                            <Grid item xs={12}>
                                                <Typography variant="subtitle1" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <InventoryIcon color="primary" />
                                                    Materiales Utilizados
                                                </Typography>

                                                <Paper sx={{ p: 2, mb: 2, bgcolor: '#f8f9fa' }}>
                                                    <Grid container spacing={2} alignItems="center">
                                                        <Grid item xs={12} md={5}>
                                                            <MaterialBuscador
                                                              ticketId={ticket?.id}
                                                              tecnicoId={ticket?.assigned_technician_id}
                                                              modo="stock"
                                                              value={nuevoMaterial.material_id}
                                                              onSelect={seleccionarMaterial}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={2}>
                                                            <TextField
                                                                fullWidth
                                                                type="number"
                                                                label="Cantidad"
                                                                size="small"
                                                                value={nuevoMaterial.cantidad}
                                                                onChange={(e) => setNuevoMaterial({ ...nuevoMaterial, cantidad: e.target.value })}
                                                                onFocus={(e) => e.target.select()}
                                                                inputProps={{ min: 1, step: 1 }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={4}>
                                                            <TextField fullWidth label="Observaciones" size="small" value={nuevoMaterial.observaciones} onChange={(e) => setNuevoMaterial({ ...nuevoMaterial, observaciones: e.target.value })} />
                                                        </Grid>
                                                        <Grid item xs={12} md={1}>
                                                            <Button fullWidth variant="contained" onClick={agregarMaterial} startIcon={<AddIcon />} disabled={!nuevoMaterial.material_id}>
                                                                Agregar
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                </Paper>

                                                {materialesUtilizados.length > 0 && (
                                                    <List dense sx={{ mb: 2, bgcolor: '#fafafa', borderRadius: 1 }}>
                                                        {materialesUtilizados.map((mat, idx) => (
                                                            <React.Fragment key={idx}>
                                                                <ListItem>
                                                                    <ListItemText
                                                                        primary={<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                            <strong>{mat.nombre}</strong>
                                                                            <Chip label={`x${mat.cantidad}`} size="small" color="primary" />
                                                                        </Box>}
                                                                        secondary={mat.observaciones || 'Sin observaciones'}
                                                                    />
                                                                    <ListItemSecondaryAction>
                                                                        <IconButton edge="end" onClick={() => eliminarMaterial(idx)} size="small" color="error">
                                                                            <DeleteIconMaterial />
                                                                        </IconButton>
                                                                    </ListItemSecondaryAction>
                                                                </ListItem>
                                                                <Divider />
                                                            </React.Fragment>
                                                        ))}
                                                    </List>
                                                )}
                                            </Grid>

                                            {/* VIÑETA */}
                                            <Grid item xs={12}>
                                                <Divider sx={{ my: 2 }} />
                                                <Typography variant="subtitle1" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <VignetteIcon color="warning" />
                                                    Gestión de Viñeta (Opcional)
                                                </Typography>

                                                <Alert severity="info" sx={{ mb: 2 }}>
                                                    <strong>🏷️ Viñeta actual:</strong> {ticket?.vineta || customerVineta || 'Sin viñeta'}
                                                </Alert>

                                                <Grid container spacing={2} alignItems="center">
                                                    <Grid item xs={12} md={6}>
                                                        <FormControlLabel
                                                            control={
                                                                <Switch
                                                                    checked={vinetaRetirar}
                                                                    onChange={(e) => {
                                                                        setVinetaRetirar(e.target.checked);
                                                                        if (e.target.checked) setVinetaNueva('');
                                                                    }}
                                                                    color="error"
                                                                    disabled={!ticket?.vineta && !customerVineta}
                                                                />
                                                            }
                                                            label={<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                <DeleteIconVignette color={vinetaRetirar ? 'error' : 'disabled'} />
                                                                <Typography variant="body2">Retirar viñeta</Typography>
                                                            </Box>}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                                            <Typography variant="body2" sx={{ minWidth: 'fit-content' }}>Cambiar a:</Typography>
                                                            <VinetaBuscador
                                                              opciones={vignettesDisponibles}
                                                              value={vinetaNueva}
                                                              onChange={(serial) => {
                                                                setVinetaNueva(serial);
                                                                if (serial) setVinetaRetirar(false);
                                                              }}
                                                              disabled={vinetaRetirar || cargandoVignettes}
                                                              vacio="Sin cambio"
                                                            />
                                                            {cargandoVignettes && <CircularProgress size={20} />}
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Button variant="contained" onClick={handleUpdateFieldWork} disabled={loading} startIcon={<EngineeringIcon />} sx={{ mr: 2 }}>
                                                    Guardar Trabajo
                                                </Button>
                                                {canResolve && (
                                                    <Button variant="contained" color="success" onClick={handleResolve} disabled={loading} startIcon={<CheckCircleIcon />}>
                                                        Marcar como Resuelto
                                                    </Button>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Box>
                                )}

                                {activeTab === 4 && (
                                    <Box>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <Paper variant="outlined" sx={{ p: 2 }}>
                                                    <Typography variant="subtitle2" gutterBottom>Notas de resolución</Typography>
                                                    <Typography variant="body2">{ticket.resolution_notes || 'No hay notas'}</Typography>
                                                    {ticket.resolved_at && (
                                                        <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
                                                            Resuelto el: {format(new Date(ticket.resolved_at), 'dd/MM/yyyy HH:mm')}
                                                        </Typography>
                                                    )}
                                                </Paper>
                                            </Grid>
                                            {canClose && (
                                                <Grid item xs={12}>
                                                    <Button variant="contained" color="success" onClick={handleCloseTicket} disabled={loading} startIcon={<CheckCircleIcon />} fullWidth>
                                                        Cerrar Ticket Definitivamente
                                                    </Button>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Box>
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions>
                    {canCloseInstallation && (
                        <Button variant="contained" color="success" onClick={handleCloseInstallation} disabled={loading} startIcon={<CheckCircleIcon />} sx={{ mr: 1 }}>
                            Completar Instalación
                        </Button>
                    )}
                    {canCloseRetiro && (
                        <Button variant="contained" color="warning" onClick={handleCloseRetiro} disabled={loading} startIcon={<WarningIcon />} sx={{ mr: 1 }}>
                            Completar Retiro
                        </Button>
                    )}
                    {canCloseCambio && (
                        <Button variant="contained" color="info" onClick={handleCloseCambio} disabled={loading} startIcon={<SwapHorizIcon />} sx={{ mr: 1 }}>
                            Completar Cambio (Diálogo)
                        </Button>
                    )}
                    {canReopen && (
                        <Button variant="contained" color="warning" onClick={handleReopenTicket} disabled={loading} startIcon={<ReplayIcon />} sx={{ mr: 1 }}>
                            Reabrir Ticket
                        </Button>
                    )}
                    {user?.is_superuser || user?.roles?.includes('admin') || user?.roles?.includes('supervisor') ? (
                        <Button variant="contained" color="error" onClick={handleDeleteTicket} disabled={loading} startIcon={<DeleteIcon />}>
                            Eliminar Ticket
                        </Button>
                    ) : null}
                    <Button onClick={onClose} disabled={loading}>Cerrar</Button>
                </DialogActions>
            </Dialog>

            <CloseInstalacionDialog open={closeDialogOpen} onClose={() => setCloseDialogOpen(false)} ticket={ticket} onSuccess={handleCloseSuccess} />
            <CloseRetiroDialog open={closeRetiroDialogOpen} onClose={() => setCloseRetiroDialogOpen(false)} ticket={ticket} onSuccess={handleCloseSuccess} />
            <CloseCambioEquipoDialog open={closeCambioDialogOpen} onClose={() => setCloseCambioDialogOpen(false)} ticket={ticket} onSuccess={handleCloseSuccess} />
            <ClienteBitacora open={bitacoraClienteOpen} onClose={() => setBitacoraClienteOpen(false)} customerId={ticket?.customer_id} customerName={ticket?.customer_name} />
        </>
    );
}
